<script>
    import user from "../stores/user";
    import Step1_FindAccount from "./Step1_FindAccount.svelte";
    import Step2_VerifyAccount from "./Step2_VerifyAccount.svelte";
    import Step3_CreateAccount from "./Step3_CreateAccount.svelte";

    const FORM_STEP = {
        FIND_ACCOUNT: 1,
        VERIFY_ACCOUNT: 2,
        CREATE_ACCOUNT: 3,
    }

    let step = 1;
    let afm = null;
    let account = null;

    const componentCallback = (params) => {
        if (params.action === 'confirm') {
            account = {
                id: params.id,
                email: params.email
            }
            step = FORM_STEP.VERIFY_ACCOUNT;
        } else if (params.action === 'create') {
            step = FORM_STEP.CREATE_ACCOUNT;
            afm = params.afm;
        }
    }

    // DEBUG
    // afm = '1234567890';
    // step = 3;

    $: {
        if ($user.token) {
            window.location.href = "/my-account";
        }
    }
</script>
<div class="container">
    <div class="mb-5">
        <h1>Εγγραφή - Επαλήθευση</h1>
        <div class="heading-separator"></div>
    </div>
    {#if step == FORM_STEP.FIND_ACCOUNT}
        <Step1_FindAccount callbackFunction={componentCallback}/>
    {:else if step == FORM_STEP.VERIFY_ACCOUNT}
        <Step2_VerifyAccount {account}/>
    {:else if step == FORM_STEP.CREATE_ACCOUNT}
        <Step3_CreateAccount {afm}/>
    {/if}
</div>